import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-efecty-baloto',
  templateUrl: './efecty-baloto.component.html',
  styleUrls: ['./efecty-baloto.component.css'],
})
export class EfectyBalotoComponent implements OnInit {
  public convenioBaloto: string;
  public convenioCorresponsalBancario: string;
  public convenioEfecty: string;
  public convenioSusuerte: string;
  public referencia: string;

  constructor(private _dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private _data: any) {}

  ngOnInit() {
    this.convenioCorresponsalBancario = this._data.convenioCorresponsalBancario;
    this.convenioBaloto = this._data.convenioBaloto.value;
    this.convenioEfecty = this._data.convenioEfecty.value;
    this.convenioSusuerte = this._data.convenioSusuerte.value;
    this.referencia = this._data.referencia;
  }

  public closedModal() {
    this._dialog.closeAll();
  }
}
